module.exports = "/images/body-right.svg?e13721934a2cbabb13de4b1f061c436b";